// extracted by mini-css-extract-plugin
module.exports = {"avatars":"avatars__OozOq","avatar":"avatar__Fxc4C"};